var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 13.5451 13.5451",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.59085 8.8634H2.17268C1.24574 8.8634 0.5 8.11767 0.5 7.19072V2.17268C0.5 1.24574 1.24574 0.5 2.17268 0.5H7.19072C8.11767 0.5 8.8634 1.24574 8.8634 2.17268V2.59085M6.35438 4.6817H11.3724C11.816 4.6817 12.2415 4.85793 12.5552 5.17162C12.8689 5.48531 13.0451 5.91076 13.0451 6.35438V11.3724C13.0451 11.816 12.8689 12.2415 12.5552 12.5552C12.2415 12.8689 11.816 13.0451 11.3724 13.0451H6.35438C5.91076 13.0451 5.48531 12.8689 5.17162 12.5552C4.85793 12.2415 4.6817 11.816 4.6817 11.3724V6.35438C4.6817 6.13472 4.72497 5.91721 4.80903 5.71427C4.89309 5.51134 5.0163 5.32694 5.17162 5.17162C5.32694 5.0163 5.51134 4.89309 5.71427 4.80903C5.91721 4.72497 6.13472 4.6817 6.35438 4.6817Z",
    stroke: "#5A76C9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.7251061a26dd2a109881d75062d01bbb.svg";
export { ForwardRef as ReactComponent };